import { setLoading, setGlobalMessage } from '../../app';
import ApiDataHelper from 'eebac/utils/apiDataHelper';
import QUOTATION from 'eebac/constants/fields/vendor/rfq/quotation';
import { ALERT_SEVERITY, ERROR_MESSAGES, VALIDATION_MESSAGES } from 'eebac/constants';
import { Catch } from '../../api_exception';
import { loadRfqs, viewRfq } from '../rfqs';


const BASE_PATH = 'VENDOR_RFQ_QUOTATION';

export const SET_RFQ_DATA = `${BASE_PATH}/SET_RFQ_DATA`;
export const CLEAR_INFO_DATA = `${BASE_PATH}/CLEAR_INFO_DATA`;

export const sendRfqQuotation = (id) =>
    (dispatch, getState, client) => {

        let state = getState();
        state = state.VENDOR_RFQ_QUOTATION;

        let FIELDS = {
            ...QUOTATION,
        };

        dispatch(setLoading(true));
        let apiData = ApiDataHelper.get(state, FIELDS);
        client.post("/vendor/rfq/quotation/" + id, apiData)
            .then(res => res.data).then(result => {
                dispatch(setLoading(false));
                if (result.isSuccess) {
                    dispatch(setGlobalMessage(result.successMessage,
                        ALERT_SEVERITY.SUCCESS));
                    dispatch(clearRfqQuotationData());
                    dispatch(viewRfq(false));
                    dispatch(loadRfqs());
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }

            }).catch(error => {
                Catch(error, dispatch);
            });
    }

export const setRfqQuotationData = data => ({
    type: SET_RFQ_DATA,
    data
});

export const clearRfqQuotationData = () => ({
    type: CLEAR_INFO_DATA,
});

const initialState = {
    quotation: null,
}

export default function reducer(state = { ...initialState }, action) {
    switch (action.type) {
        case SET_RFQ_DATA:
            let newState = { ...state };
            action.data.forEach(data => {
                newState[data.key] = data.value;
            });
            return newState;
        case CLEAR_INFO_DATA:
            return { ...initialState }
    }

    return state;
}